import { useCallback, useId } from 'react'
import { ChartWrapperOptions } from 'react-google-charts'
import { ChartWrapperProps } from '../Cockpit.types'
import GoogleChart from './GoogleChart'

type PieChartProps = Pick<
  ChartWrapperProps,
  'data' | 'chartLanguage' | 'options' | 'title'
>

const PieChart = ({ title, data, options, chartLanguage }: PieChartProps) => {
  const chartUuid = useId()

  const handleChartSelect = useCallback(
    ({ chartWrapper }: ChartWrapperOptions['chartEvents']) => {
      const chart = chartWrapper.getChart()
      const selection = chart.getSelection()
      if (selection.length > 0) {
        const selectedItem = selection[0]
        const dataTable = chartWrapper.getDataTable()
        if (selectedItem.row !== null) {
          const value = dataTable.getValue(selectedItem.row, 1)

          return value
        }
      }
    },
    []
  )

  const chartEvents = [
    {
      eventName: 'select',
      callback: handleChartSelect
    }
  ]

  return (
    <GoogleChart
      title={title}
      chartModel='PieChart'
      chartUuid={chartUuid}
      data={data}
      options={options}
      chartEvents={chartEvents}
      chartLanguage={chartLanguage}
    />
  )
}

export default PieChart
